import React, {useEffect, useState} from "react";
import "./OnlineStoreCat.scss";
import {OnlineCategories, OnlineOff, OnlineSearch, OnlineSlider, OnlineSwiper, Slider} from "../../Components";
import {StoreOnlineCatsData} from "./OnlineStoreCatService";
//import {sort} from "fusioncharts/datastore/operators";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {OnlineCatBar} from "../../Components/OnlineCatBar/OnlineCatBar";
import ReactGA from "react-ga";



function OnlineStoreCat() {
    //hooks
    const history = useHistory();
    const { merchantId,catId } = useParams();
    const location  = useLocation();

    //states
    const [cats,set_cats] = useState(null);
    const [currentCats,set_currentCats] = useState(null);
    const [currentMerchant,set_currentMerchant] = useState(null);
    const [currentPath,set_currentPath] = useState(null);
    const [oldPath,set_oldPath] = useState(null);

    useEffect(()=>{
        // console.log("Merchant1 : ",merchantId)
        // console.log("Cat1 : ",catId)
        if(merchantId && catId){
            getCats(merchantId,catId);
        }
        set_currentPath(location.pathname)
    },[]);



    const getCats = async (merId,caId) =>{
        const response = await StoreOnlineCatsData(merId,caId);
        // console.log("Catss : ",response.data);
        set_cats((list)=>response.data);

    }

    const changeCats = (cat) =>{
        // console.log("cat: ",cat)
        if(cat.childes.length<1){
            history.push(`/online-store-sub-categories/${merchantId}/${cat.uid}`)
        }else {
            history.push(`/online-store-categories/${merchantId}/${cat.uid}`)
            set_oldPath(currentPath)
            set_currentPath(`/online-store-categories/${merchantId}/${cat.uid}`)
            getCats(merchantId,cat.uid)
        }
    }

    const back = () =>{
        // console.log(cats)
        if(cats){
            if(cats[0].parent.parent){
                history.push(`/online-store-categories/${merchantId}/${cats[0].parent.parent.uid}`)
                getCats(merchantId,cats[0].parent.parent.uid)
            }else {
                history.push(`/online-store/${merchantId}`)
            }
        }

        // if(oldPath){
        //     let pCurrent = currentPath.split("/")[1];
        //     let oCurrent = oldPath.split("/")[1];
        //     if(pCurrent===oCurrent){
        //         getCats(oldPath.split("/")[2],oldPath.split("/")[3])
        //     }
        //     history.goBack()
        //     set_oldPath(`/online-store-categories/${currentPath.split("/")[2]}/${currentPath.split("/")[3]}`)
        //     set_currentPath(`/online-store-categories/${oldPath.split("/")[2]}/${oldPath.split("/")[3]}`)
        // }else {
        //     history.goBack()
        // }
    }

    return(
        <div className="online-store-cat">
            <OnlineSearch back={back} merchantId={merchantId}/>
            {cats?<OnlineCatBar cats={cats} changeCats={changeCats}/>:null}
            {cats && cats.map(cat=>{
                return(
                    <OnlineSwiper merchantId={merchantId} title={cat.name} more={cat.uid} list={cat.selective_products}/>
                )
            })}
        </div>
    )
}

export {OnlineStoreCat};
